type Args = {
  netHeight: number;
  screenType: string;
  swingDirection?: string;
  alumThickFrame?: boolean;
};

export function calculateAlumSideliteHeight(sideliteArgs: Args) {
  const { netHeight, screenType } = sideliteArgs;
  var slHeight = 0;

  const sub = screenType?.includes("Centor") ? 2.5 : 0;

  if (sideliteArgs.alumThickFrame) {
    slHeight =
      sideliteArgs.swingDirection === "Outswing"
        ? netHeight - 2.283006 - sub
        : netHeight - 2.188922;

    return slHeight;
  }

  slHeight =
    sideliteArgs.swingDirection === "Outswing"
      ? netHeight - 1.535413 - sub //thin frame
      : netHeight - 1.440942; //thin frame

  return slHeight;
}
